<div class="dialog-wrapper">
  <!-- Header -->
  <div class="dialog-header">
    <button class="close-btn" (click)="onClose()" type="button">&times;</button>
    <h2 class="dialog-title">Freeze History</h2>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- Table -->
    <table class="freeze-table">
      <thead>
        <tr>
          <th>Freeze<br />Startdate</th>
          <th>Freeze<br />Enddate</th>
          <th>Freeze<br />Note</th>
          <th>Freeze<br />Creator</th>
          <th>Freeze<br />Creation<br />Date</th>
          <th>Freeze<br />Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let freeze of freezes">
          <td>{{ freeze.startDate }}</td>
          <td>{{ freeze.endDate }}</td>
          <td>{{ freeze.note }}</td>
          <td>{{ freeze.creator }}</td>
          <td>{{ freeze.creationDate }}</td>
          <td>{{ freeze.actions }}</td>
        </tr>
        <tr *ngIf="freezes.length === 0">
          <td colspan="6" style="text-align: center; color: #999">
            No freeze history
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="close-footer-btn" (click)="onClose()">Close</button>
  </div>
</div>
